import { RPCs } from "../../../services/rpc.js";
import { useRPC } from "../../../hooks/useRPC/index.js";
//#region src/modules/Locations/hooks/useLocationLogEntry.ts
function useLocationLogEntry(args, opts = {}) {
	const { call, data, isCalling } = useRPC(RPCs.Locations.GetLocationLogEntryDetail.v1, args, {
		cacheStrategy: opts.cacheStrategy,
		fire: opts.fire || !!args
	});
	return {
		data,
		loading: isCalling,
		refresh: call
	};
}
//#endregion
export { useLocationLogEntry };

//# sourceMappingURL=useLocationLogEntry.js.map